export default function Field({ label, htmlFor, children }) {
  return (
    <div>
      <label
        htmlFor={htmlFor}
        className="block text-[10px] tracking-widest3 uppercase text-ink/55 mb-3"
      >
        {label}
      </label>
      {children}
    </div>
  );
}
